import Image from 'app/Components/Shared/Image/image';
import React from 'react';
import BtnSubmit from '../../../Shared/Buttons/BtnSubmit';
const DeviceSupportsESIMCheckBox = (props) => {
  return (
    <div className='device-supports-esim-popup'>
      <Image src={require('../icons/error.svg')} />
      <p className='L_Title'>
        לתשומת ליבך,
        <br />
        עליך לאשר שהמכשיר תומך ב-eSIM בשביל להתקדם בהזמנה
      </p>
      <BtnSubmit text={'הבנתי, תודה'} onclick={() => props.buttonClick(false)} />
    </div>
  );
};
export default DeviceSupportsESIMCheckBox;
